import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Flex } from '$components/layouts';
import { theme } from '$theme';
import { useBasket } from '~/store';
import { useTranslation } from '$hooks';
import { Text } from '$components/elements/text';
import { Button } from '$components/elements/button';

type Props = {
    invalidLines?: string[];
};

export const BasketInvalidLines: FC<Props> = ({ invalidLines }) => {
    const { translate } = useTranslation();
    const { removeBasketLine } = useBasket();

    return (
        <BasketInvalidLinesContainer column>
            <Text h6 color={theme.colors.errorTxt}>
                {translate('basket.invalidLines.title')}
            </Text>
            <Text bottomMargin="2">{translate('basket.invalidLines.body')}</Text>
            {invalidLines?.map((line) => (
                <Flex key={line}>
                    <Text>{line}</Text>
                    <RemoveItem variant="link" onClick={() => removeBasketLine(line)}>
                        {translate('productItem.productRowItem.removeProduct')}
                    </RemoveItem>
                </Flex>
            ))}
        </BasketInvalidLinesContainer>
    );
};

const BasketInvalidLinesContainer = styled(Flex)(({ theme }) => ({
    backgroundColor: theme.colors.grey5,
    padding: theme.space[3],
    marginBottom: theme.space[6],
}));

const RemoveItem = styled(Button)(({ theme }) => ({
    fontSize: theme.fontSizes.sm,
    fontWeight: theme.fontWeights.regular,
    color: theme.colors.red,
    marginLeft: theme.space[8],
}));
